export const SET_EVENT_IMAGE = 'SET EVENT DATA IMAGE'
export const SET_RANKING = 'SET RANKING'
export const SET_ONLINE = 'SET ONLINE'
export const SET_LOADING = 'SET LOADING'
export const SET_DOWNLOAD_LINK = 'SET DOWNLOAD LINK'
export const SET_SERVER_INFO = 'SET SERVER INFO'
export const SET_EVENTS = 'SET EVENTS'
export const SET_DONATION_DETAILS = 'SET DONATION DETAILS'
export const SET_SHOW_ONLINE = 'SET SHOW ONLINE'